/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiRoomShareTokenFromJSON, StreemApiRoomShareTokenToJSON, } from './';
export function StreemApiAuthIdentityRoomShareTokenFromJSON(json) {
    return StreemApiAuthIdentityRoomShareTokenFromJSONTyped(json, false);
}
export function StreemApiAuthIdentityRoomShareTokenFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'roomShareToken': !exists(json, 'room_share_token') ? undefined : StreemApiRoomShareTokenFromJSON(json['room_share_token']),
    };
}
export function StreemApiAuthIdentityRoomShareTokenToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'room_share_token': StreemApiRoomShareTokenToJSON(value.roomShareToken),
    };
}
//# sourceMappingURL=StreemApiAuthIdentityRoomShareToken.js.map